<template>
  <structure>
    <b-alert v-if="error" v-model="error" variant="danger" dismissible>{{error}}</b-alert>
    <b-row>
      <b-col>
        <p class="pt-3 font-weight-bold mb-0">Developer Options</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <p class="pt-3 mb-0">
          Artifact cache: {{$store.getters.artifacts.length}}
          <a
            class="float-right"
            href="#"
            @click="clearArtifacts()"
          >Clear</a>
        </p>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <label>Dev API server</label>
        <b-form-input size="sm" style="background-color: white !important;" v-model="devServer"></b-form-input>
      </b-col>
    </b-row>
  </structure>
</template>

<script>
import Structure from './Structure';

export default {
  name: 'Developer',
  components: {
    Structure,
  },
  extends: Structure,
  data() {
    return {
      error: null,
    };
  },
  mounted() {},
  methods: {
    clearArtifacts() {
      this.$store.commit('clearArtifacts');
    },
  },
  computed: {
    devServer: {
      get() {
        return this.$store.getters.devServer;
      },
      set(value) {
        if (/https:\/\/[a-z0-9.\-:]*\//.test(value)) {
          this.$store.commit('updateDevServer', value);
          this.error = null;
        }
        else this.error = `dev server must match /https?://[a-z0-9.-:]*//`;
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
